import styled from '@emotion/styled';
import { css } from '@emotion/core';

const baseStyles = ({ theme }) => css`
  background-color: ${theme.colors.n700};
  width: 1px;
  height: 100px;
`;

const Pipe = styled('div')(baseStyles);

export default Pipe;
